"use strict";
var Observable_1 = require('../../Observable');
var delayWhen_1 = require('../../operator/delayWhen');
Observable_1.Observable.prototype.delayWhen = delayWhen_1.delayWhen;
//# sourceMappingURL=delayWhen.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/bishop.duperret.GOMURAL/Documents/ConciergeDashboard/gomural-mural-outlook-configuration-dashboard-43c2b5785cd3/~/rxjs/add/operator/delayWhen.js
// module id = ../../../../rxjs/add/operator/delayWhen.js
// module chunks = 27